import {Injectable} from '@angular/core';
import {CodeDesignation} from '@sigale-angular/src/models/codeDesignation.model';

@Injectable({
	providedIn: 'root'
})
export class StorageService {

	readonly CLE_MASQUER_RESERVATIONS = 'estMasquerReservations';

	readonly CLE_PLANNING_EQUIPES_SELECTIONNEES = 'planningEquipesSelectionnees';
	readonly CLE_PLANNING_UTILISATEURS_SELECTIONNES = 'planningUtilisateursSelectionnes';
	readonly CLE_PLANNING_GROUPES_DE_TRAVAIL_SELECTIONNES = 'planningGroupesDeTravailSelectionnes';

	private _dernierTypeEvenementSelectionne: CodeDesignation;

	constructor() {
	}

	setMasquerReservationsDeBureau(valeur: boolean) {
		localStorage.setItem(this.CLE_MASQUER_RESERVATIONS, JSON.stringify(valeur));
	}

	estMasquerReservationsDeBureau(): boolean {
		return JSON.parse(localStorage.getItem(this.CLE_MASQUER_RESERVATIONS) ?? 'false');
	}

	get dernierTypeEvenementSelectionne(): CodeDesignation {
		return this._dernierTypeEvenementSelectionne;
	}

	set dernierTypeEvenementSelectionne(value: CodeDesignation) {
		this._dernierTypeEvenementSelectionne = value;
	}

	get planningEquipesSelectionnees(): number[] | null {
		const item = localStorage.getItem(this.CLE_PLANNING_EQUIPES_SELECTIONNEES);
		return item ? JSON.parse(item) : null;
	}

	set planningEquipesSelectionnees(equipesIds: number[]) {
		localStorage.setItem(this.CLE_PLANNING_EQUIPES_SELECTIONNEES, JSON.stringify(equipesIds));
	}

	get planningGroupesDeTravailSelectionnes(): number[] | null {
		const item = localStorage.getItem(this.CLE_PLANNING_GROUPES_DE_TRAVAIL_SELECTIONNES);
		return item ? JSON.parse(item) : null;
	}

	set planningGroupesDeTravailSelectionnes(groupesDeTravailIds: number[]) {
		localStorage.setItem(this.CLE_PLANNING_GROUPES_DE_TRAVAIL_SELECTIONNES, JSON.stringify(groupesDeTravailIds));
	}
}
